import React, { FC } from 'react'
import ViewCompany from 'containers/Companies/ViewCompany'

const CompanyPage: FC = () => <ViewCompany />

export default CompanyPage
